import styled from 'styled-components';

export const SectionedListHeading = styled.p`
  padding: ${({ theme }) => theme.spacing(15)} 0 ${({ theme }) => theme.spacing(10)} 0;
  margin: 0 ${({ theme }) => theme.spacing(15)};
  border-top: 1px solid ${({ theme }) => theme.colours.gallery};
  width: 248px;
  font-size: ${({ theme }) => theme.pxToRem(12)};
  font-weight: 600;
  line-height: 1.5888;
`;

export const SectionedListValues = styled.div`
  padding: ${({ theme }) => theme.spacing(15)};

  p {
    font-size: ${({ theme }) => theme.pxToRem(14)};
    line-height: 1.5;
    display: flex;
    gap: ${({ theme }) => theme.spacing(5)};
  }

  p + p {
    margin-top: ${({ theme }) => theme.spacing(10)};
  }

  span {
    display: flex;
    font-size: 14px;
    color: ${({ theme }) => theme.colours.charcoalDust};
  }

  span + span {
    margin-left: ${({ theme }) => theme.spacing(6)};
    color: ${({ theme }) => theme.colours.crowberryBlue};
  }

  p span:nth-child(1) {
    flex: 1;
  }

  p span:nth-child(2) {
    flex: 2;
  }
`;

export const SectionedListCTA = styled.div`
  padding: ${({ theme }) => theme.spacing(15)} 0;
  margin: 0 ${({ theme }) => theme.spacing(15)};
  border-top: 1px solid ${({ theme }) => theme.colours.gallery};
  width: 248px;
  text-align: right;

  a {
    color: ${({ theme }) => theme.colours.crowberryBlue};
    text-decoration: none;
    font-size: ${({ theme }) => theme.pxToRem(14)};
    font-weight: 600;
  }
`;
